import { useTranslation } from 'react-i18next';
import { useLockersContext } from '../contexts/LockersContext';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SearchInput from './SearchInput';
import { useAccordionContext } from '../contexts/AccordionContext';
import SwitchVisibleComponent from './SwitchVisibleComponent';
import { bottom } from "@popperjs/core/lib/enums";
import { useFiltersContext } from '../contexts/FiltersContext';
import { FilterIcon } from './Miscellaneous';
import { PointLocation } from '../data/LockerDataTypes';
import React from 'react';

export const LocationFilter = () => {
    const { t } = useTranslation();
    const { setGeolocation } = useLockersContext();
    const { setAccordionExpanded } = useAccordionContext();
    const { showFilters, setShowFilters, filterCounter } = useFiltersContext();
    const [showPrimaryFindMe, setShowPrimaryFindMe] = React.useState(false);

    const getLocation = (): void => {
        const findMeButton = document.getElementById("locker-find-me-on-map-button");
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const location: PointLocation = { lng: position.coords.longitude, lat: position.coords.latitude };
                setGeolocation(location);
                findMeButton?.blur();
                setShowPrimaryFindMe(false);
            },
                errorHandler,
                { timeout: 10000 });
        } else {
            setTimeout(() => { findMeButton?.blur(); setShowPrimaryFindMe(false); }, 5000);
            return alert(t('locationError1'));
        }
    }

    const handleOnClick = () => {
        setShowFilters(!showFilters);
    }

    const errorHandler = (err: any): void => {
        const findMeButton = document.getElementById("locker-find-me-on-map-button");
        setTimeout(() => { findMeButton?.blur(); setShowPrimaryFindMe(false); }, 5000);
        if (err.code == 1) {
            return alert(t('locationError2'));
        }
        if (err.code == 2 || err.code == 3) { //POSITION_UNAVAILABLE or TIMEOUT
            return alert(t('locationError3'));
        }
    }

    const handleFindMeOnMap = (): void => {
        setAccordionExpanded(false);
        setShowPrimaryFindMe(true);
        getLocation();
    }

    const getTooltipText = () => {
        return t('locationDisclaimer');
    }

    return (
        <div className={'d-grid rounded locker-plugin-box-container'}>
            <div className='mx-auto d-flex w-100 gap-1'>
                <SearchInput />
            </div>
            <div className='filter-container'>
                <OverlayTrigger placement={bottom} delay={100} overlay={
                    <Tooltip className='locker-plugin-location-tooltip opacity-75'>
                        {getTooltipText()}
                    </Tooltip>}>
                    <Button variant={showPrimaryFindMe ? "primary" : "outline-primary"} size="sm" id="locker-find-me-on-map-button"
                        className="text-nowrap locker-plugin-find-me-on-map" onClick={handleFindMeOnMap}>{t('findMeOnMap')}</Button>
                </OverlayTrigger>
                <form>
                    <Button variant={showFilters ? "primary" : "outline-primary"} size="sm"
                        className="text-nowrap"
                        onClick={handleOnClick}>{t("advancedFilters")}{filterCounter > 0 ? '(' + filterCounter + ') ' : ' '}
                        <FilterIcon />
                    </Button>
                </form>
            </div>

            <SwitchVisibleComponent />

        </div>
    )

}

export default LocationFilter;
